import { render } from "./FormPruefprotokoll_Schiebetueren.vue?vue&type=template&id=5b079f20&scoped=true"
import script from "./FormPruefprotokoll_Schiebetueren.vue?vue&type=script&lang=js"
export * from "./FormPruefprotokoll_Schiebetueren.vue?vue&type=script&lang=js"

import "./FormPruefprotokoll_Schiebetueren.vue?vue&type=style&index=0&id=5b079f20&lang=scss&scoped=true"

import exportComponent from "/home/hiro/lab/hands4you-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b079f20"]])

export default __exports__